import { render, staticRenderFns } from "./Grupy.vue?vue&type=template&id=c6a38978&scoped=true&"
import script from "./Grupy.vue?vue&type=script&lang=js&"
export * from "./Grupy.vue?vue&type=script&lang=js&"
import style0 from "./Grupy.vue?vue&type=style&index=0&id=c6a38978&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a38978",
  null
  
)

export default component.exports